import  { useState } from "react";
import Document from "./documents";

const Product = (props: any) => {
  const { product, lang } = props;

  const [status, setStatus] = useState(props.status);
  const [documentText, setDocumentText] = useState(false);

  const openDocuments = () => {
    setStatus(!status);
  };

  const changeDocumentText = () => {
    setDocumentText(!documentText);
  };

  const documentsCount = product.documents.length;

  const productClass =
    status && documentsCount > 0 ? "m-product m-product--open" : "m-product";

  const documentClass = status
    ? "m-product__documents m-product__documents--open"
    : "m-product__documents";

  const icon = !status
    ? "m-product__info__icon icon-plus"
    : "m-product__info__icon icon-minus";

  const labelEn =
    product.labelEn !== "" ? (
      <p className="m-product__info__name__en">{product.labelEn}</p>
    ) : null;

  // ---- Documents text ----
  let documentTextLabel;

  if (documentsCount === 0) {
    documentTextLabel =
      lang === "fr" ? (
        <span>Documents bientôt disponible</span>
      ) : (
        <span>Documents coming soon</span>
      );
  } else if (documentsCount === 1) {
    documentTextLabel = <span>1 document</span>;
  } else {
    documentTextLabel = <span>{documentsCount} documents</span>;
  }

  if (documentText && documentsCount > 0 && !status) {
    documentTextLabel =
      lang === "fr" ? (
        <span>Afficher les documents</span>
      ) : (
        <span>View documents</span>
      );
  }

  // ---- Documents list ----
  
  let documents: any;
  if (documentsCount > 0) {
    documents = (
      <div className={documentClass} 
      aria-label={
        lang === "fr"
        ? `Documents du produit ${product.label}`
        : `Documents for product ${product.label}`
      }>
        <div className="m-product__documents__box">
          {product.documents.map((x) => (
            <Document key={x.id} document={x} lang={lang} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={productClass}>
      <div

        onMouseEnter={changeDocumentText}
        onMouseLeave={changeDocumentText}
        onClick={openDocuments}
        className="m-product__info"
        aria-expanded={status}
        aria-controls={`documents-${product.id}`}
      >
        <div className="m-product__info__name">
          <p className="m-product__info__name__fr">{product.label}</p>
          <p className="m-product__info__ref">
            {product.references.map((x) => x + " ")}
          </p>
        </div>

        {labelEn}

        <p className="m-product__info__documents">
          <span className="m-product__info__documents__icon icon-document" aria-hidden="true"></span>
          {documentTextLabel}
        </p>

        {documentsCount > 0 && <p className={icon}></p>}
      </div>

      {documents}
    </div>
  );
};

export default Product;
